module.exports = __webpack_public_path__ + "static/media/submit-doc.91bf655e.svg";